import { render } from "./EditOffTrade.vue?vue&type=template&id=6d8d5b93&scoped=true"
import script from "./EditOffTrade.vue?vue&type=script&lang=js"
export * from "./EditOffTrade.vue?vue&type=script&lang=js"

import "./EditOffTrade.vue?vue&type=style&index=0&id=6d8d5b93&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8d5b93"]])

export default __exports__